import PersonSearchOutlinedIcon from "@mui/icons-material/PersonSearchOutlined";
import { ButtonVariantOption, LinkButton } from "@/components/Button";
import { SizingWrapperStyle } from "@/components/Wrapper";

export const OwnerInfoAnalyzeButton: React.FC = () => {
  return (
    <LinkButton
      variant={ButtonVariantOption.Text}
      startIcon={<PersonSearchOutlinedIcon />}
      href={"/ownerinfo/list"}
      wrapperSize={SizingWrapperStyle.INHERIT}
      sx={{ color: "darkgray.main", fontWeight: 400 }}
    >
      所有者事項解析一覧
    </LinkButton>
  );
};
